import { createSlice } from "@reduxjs/toolkit";

const errorSlice = createSlice({
    name: "error",
    initialState: null,
    reducers: {
        addError: (state, action) => {
            state.error = action.payload
        },
    }
});

export const { addError } = errorSlice.actions;
export default errorSlice.reducer;